export const XS = 640;
export const S = 814;
export const M = 1066;
export const L = 1400;
export const XL = 1600;
export const XXL = 1920;
export const XXXL = 2560;
export const XXXXL = 3440;

export const CSS_GE_S = `min-width: ${XS}px`
export const CSS_GE_M = `min-width: ${S}px`
export const CSS_GE_L = `min-width: ${M}px`
export const CSS_GE_XL = `min-width: ${L}px`
export const CSS_GE_XXL = `min-width: ${XL}px`
